export enum E_EstadoFormCausaDesviacion {
  Lectura = 1,
  Agregar = 2,
  Cerrar = 3,
}
export enum E_EstadoFormRegistrarCierreDesv {
  Lectura = 1,
  Cerrar = 2,
}
export enum E_EstadoFormIngresarDesv {
  Lectura = 1,
  Ingresar = 2,
  IngresarAuditoría = 3,
}
export enum E_EstadoFormIngresarLIO {
  Lectura = 1,
  Ingresar = 2,
  IngresarLIO = 3,
}
export enum E_EstadoFormPerfilamiento {
  Lectura = 1,
  Ingresar = 2,
  MarcarAccion = 3,
  RevisarCierreAcciones = 4,
}
